import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setSerial
 * @method setIsStaff
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onCloseModal
 * @method onSerialExpire
 * event
 * @event sendCloseModal
 * @event sendSerialExpire
 */
export function SerialModalController() {
    this.serialModel = null;
    this.isStaff = false;
    this.isShowStaff = false;
    this.isUsed = false;
    this.busModal = mitt();

    this.callbackClose = null;
    this.callbackSerialExpire = null;
    this.callbackCoupon = null;
    this.callbackForStaff = null;

    //#region setter
    this.setSerial = function (serialModel) {
        this.serialModel = serialModel;
        return this;
    };
    this.setIsStaff = function(isStaff){
        this.isStaff = isStaff;
        return this;
    };
    this.setIsShowStaff = function(isShowStaff){
        this.isShowStaff = isShowStaff;
        return this;
    };
    this.setIsUsed = function(isUsed){
        this.isUsed = isUsed;
        return this;
    };
    this.clearModal = function () {
        this.serialModel = null;
        this.isStaff = false;
        this.isShowStaff = false;
        this.isUsed = false;
        this.callbackClose = null;
        this.callbackDetail = null;
        this.callbackSerialExpire = null;
        this.callbackForStaff = null;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            serialModel: this.serialModel,
            isStaff: this.isStaff,
            isShowStaff: this.isShowStaff,
            isUsed: this.isUsed,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onCloseModal = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackClose = callback;
        }
    };
    this.sendCloseModal = function(data) {
        if (Util.isFunction(this.callbackClose)) {
            this.callbackClose(data);
        }
    };

    this.onClickCoupon = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackCoupon = callback;
        }
    };
    this.sendCouponModal = function(data) {
        if (Util.isFunction(this.callbackCoupon)) {
            this.callbackCoupon(data);
        }
    };

    this.onClickDetail = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackDetail = callback;
        }
    };
    this.sendClickDetail = function(data) {
        if (Util.isFunction(this.callbackDetail)) {
            this.callbackDetail(data);
        }
    };

    this.onClickForStaff = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackForStaff = callback;
        }
    };
    this.sendClickForStaff = function(data) {
        if (Util.isFunction(this.callbackForStaff)) {
            this.callbackForStaff(data);
        }
    };

    this.onSerialExpire = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackSerialExpire = callback;
        }
    };
    this.sendSerialExpire = function(data) {
        if (Util.isFunction(this.callbackSerialExpire)) {
            this.callbackSerialExpire(data);
        }
    };
    //#endregion event
}
